import shappyInfoImport from './shappyInfo'

export const setShappyInfo = shappyInfoImport
